import { render, staticRenderFns } from "./WeeklyRanking.vue?vue&type=template&id=16510790&scoped=true&"
import script from "./WeeklyRanking.vue?vue&type=script&lang=js&"
export * from "./WeeklyRanking.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyRanking.vue?vue&type=style&index=0&id=16510790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16510790",
  null
  
)

export default component.exports